import { AddColorHeader } from "./TrayPlacementTools.js"
import { TreeTopClickHandler } from "./TrayItemsClickedActions/TreeTopClickHandler.js"

export function TreeTopTab(Scene,Tray)
{
    AddColorHeader(Scene,Tray);

    const TreeTopArray = [
        Scene.addImage(0,0,"TreTpr2"),
        Scene.addImage(0,0,"TreTpr1"),
        Scene.addImage(0,0,"TreTpr4"),
        Scene.addImage(0,0,"TreTpr3"),
        Scene.addImage(0,0,"TreTpr6"),
        Scene.addImage(0,0,"TreTpr5"),
        Scene.addImage(0,0,"TreeTpr_Snwflk1"),
        Scene.addImage(0,0,"TreeTpr_Snwflk2"),
        Scene.addImage(0,0,"TreeTpr_Angl2"),
        Scene.addImage(0,0,"TreeTpr_Snta2"),
        Scene.addImage(0,0,"TreeTpr_Angl1"),
        Scene.addImage(0,0,"TreeTpr_Snta1")
    ];
    const ExtraColumnGap = 10;
    const XColumn1 = Tray.x + (TreeTopArray[0].width*.5)+ExtraColumnGap;
    const XColumn2 = Tray.x - (TreeTopArray[0].width*.5)-ExtraColumnGap;
    const IntialHeight = 115;
    const TallestTopper = 104;
    const RowGapBetween = 4;
    const NumberOfRows = TreeTopArray.length;

    Scene.TrayGroup.addMultiple(TreeTopArray);

    for (let x = 0; x < NumberOfRows; x += 2)
    {
        //console.log(x);
        TreeTopArray[x].x = XColumn1;
        TreeTopArray[x+1].x = XColumn2;
        
        if(x === 0)
        {
            TreeTopArray[x+1].y = TreeTopArray[x].y = IntialHeight + (TallestTopper*.5) + RowGapBetween;      
        }
        else
        {
            TreeTopArray[x+1].y = TreeTopArray[x].y = TreeTopArray[x-1].y + (TallestTopper) + RowGapBetween;
        }
    }

    for(let x = 0; x < 6; x++)//only adds the color changing toppers
    {
        Scene.ColorGroup.add(TreeTopArray[x]);
    }

    Scene.ColorGroup.getChildren().forEach(element =>
        {
            element.setTint(0xF70D0D);
        });

    for(let x in TreeTopArray)
    {
        TreeTopArray[x].setInteractive();
        TreeTopArray[x].on('pointerdown',TreeTopClickHandler);
    }

    //Scene.TrayGroup.clear(true,true);
}